// extracted by mini-css-extract-plugin
export default {"formlabel-18px":"OrderModel_formlabel-18px__0xR2T"};